<div c-send-introduction-messages ng-controller="sendIntroductionMessagesController as ctrl" class="modal-view send-introduction-messages">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>